import { SignatureMethod } from "@smart/bridge-types-basic";

export const DEFAULT_SIGNATURE_METHOD_STORAGE_KEY =
  "form-builder-default-signature-method";

export const getSignatureTypeAvailability = ({
  digitalSignatureEnabled,
  standardSignatureDisabled,
}: {
  digitalSignatureEnabled?: boolean;
  standardSignatureDisabled?: boolean;
}) => ({
  standard: standardSignatureDisabled !== true,
  digital: digitalSignatureEnabled === true,
});

export const resolveSignatureMethod = (
  method?: SignatureMethod | null,
): SignatureMethod => method ?? "electronic";

export const getDefaultSignatureMethod = (): SignatureMethod | undefined => {
  const stored = localStorage.getItem(DEFAULT_SIGNATURE_METHOD_STORAGE_KEY);
  if (stored === "electronic" || stored === "digital") return stored;
  return undefined;
};

export const setDefaultSignatureMethod = (method: SignatureMethod) => {
  localStorage.setItem(DEFAULT_SIGNATURE_METHOD_STORAGE_KEY, method);
};
